import { useState, useEffect } from 'react'
import { TinyColor } from '@ctrl/tinycolor';

const fontSize = 16
const padding = {
  x: 2,
  y: 2
};

export const getImageTextColor = (img) => {
  if (typeof img === 'string') {
    const tColor = new TinyColor(img);
    const bright = tColor.getBrightness()
    return bright > 125 ? "black" : "white";
  }
  if (typeof document === 'undefined') return undefined
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, img.width, img.height);
  ctx.drawImage(img, 0, 0);

  const xStart = Math.ceil((img.width * padding.x) / 100);
  const yStart = Math.ceil(
    (img.height * (100 - padding.y)) / 100 - fontSize * 1.5
  );
  const iamgeData = ctx.getImageData(
    xStart,
    yStart,
    img.width - xStart,
    img.height - yStart
  );
  const { data } = iamgeData;
  const px = data.length / 4;
  const color = Array(3).fill(0);
  for (let i = 0; i < data.length; i += 4) {
    color[0] += data[i] / px; // red
    color[1] += data[i + 1] / px; // green
    color[2] += data[i + 2] / px; // blue
  }
  const tColor = new TinyColor({ r: color[0], g: color[1], b: color[2] })
  const bright = tColor.getBrightness()
  return bright > 125 ? "black" : "white";
}

const useImageTextColor = (src) => {
  const [textColor, setTextColor] = useState()
  // const [avgColor, setColor] = useState();
  // const [bright, setBright] = useState(100);
  useEffect(() => {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.onerror = console.error
    img.onload = () => {
      setTextColor(getImageTextColor(img))
    };
    img.src = src;
  }, [src])
  return textColor
}

export default useImageTextColor
